"use strict";

exports.__esModule = true;
exports.AlertListScreen = AlertListScreen;
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _Device = require("../../Device");
var _Core = require("../../Core");
var _MasterDetailView = require("../../Core/MasterDetailView");
var _App = require("../../App");
var _System = require("../../../System");
var _AlertScreenToolbar = require("../AlertScreenToolbar");
var _Report = require("../../Report");
var _AlertGridConfig = require("../AlertGrid/AlertGridConfig");
var _AlertDetails = require("../AlertDetails");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "AlertListScreen__Wrapper",
  componentId: "sc-ew0kpo-0"
})(["display:flex;flex-direction:column;height:100vh;"]);
var GridWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AlertListScreen__GridWrapper",
  componentId: "sc-ew0kpo-1"
})(["flex:1 1 auto;position:relative;"]);
function AlertListScreen(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var devices = _react["default"].useContext(_Device.DeviceListContext);
  function handleSelect(selected) {
    var history = props.history,
      id = props.match.params.id;
    if (selected === id || selected !== undefined) {
      return;
    }
    history.push((0, _System.getScreenLocation)("AlertList"));
  }
  var id = props.match.params.id;
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("AlertListScreen.title", "Alerts")
  }, /*#__PURE__*/_react["default"].createElement(_MasterDetailView.MasterDetailView, {
    selected: id,
    onSelect: handleSelect,
    renderMaster: function renderMaster() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
        title: translate("AlertListScreen.navbar.title", "Alerts")
      }), /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(_Report.StandardReportDataProvider, {
        timeRangeKind: "multiDay"
      }, /*#__PURE__*/_react["default"].createElement(_AlertScreenToolbar.AlertScreenToolbar, {
        devices: devices
      }), /*#__PURE__*/_react["default"].createElement(GridWrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.ComponentSize, null, function (_ref) {
        var width = _ref.width,
          height = _ref.height;
        return /*#__PURE__*/_react["default"].createElement(_Report.Report, {
          config: _AlertGridConfig.config,
          width: width,
          height: height
        });
      }))))));
    },
    renderDetail: function renderDetail() {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.RootRoutes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: (0, _System.getScreenPath)("AlertDetails"),
        element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
          render: function render(props) {
            var alertId = props.match.params.id;
            if (alertId) {
              return /*#__PURE__*/_react["default"].createElement(_AlertDetails.AlertDetails, _extends({}, props, {
                alertId: alertId,
                isFullScreen: true
              }));
            }
            return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
              error: new Error("id is undefined")
            });
          }
        })
      }));
    }
  }));
}